export function bytesToBase64(bytes) {
    let s = "";
    for (let i = 0; i < bytes.length; i++)
        s += String.fromCharCode(bytes[i]);
    return btoa(s);
}
export function base64ToBytes(b64) {
    const s = atob(b64);
    const out = new Uint8Array(s.length);
    for (let i = 0; i < s.length; i++)
        out[i] = s.charCodeAt(i);
    return out;
}
export function bytesToHex(bytes) {
    let s = "";
    for (let i = 0; i < bytes.length; i++)
        s += bytes[i].toString(16).padStart(2, "0");
    return s;
}
export function hexToBytes(hex) {
    if (hex.length % 2)
        throw new Error("hex: odd length");
    const out = new Uint8Array(hex.length / 2);
    for (let i = 0; i < out.length; i++) {
        out[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
    }
    return out;
}
export function constTimeEq(a, b) {
    if (a.length !== b.length)
        return false;
    let diff = 0;
    for (let i = 0; i < a.length; i++)
        diff |= a[i] ^ b[i];
    return diff === 0;
}
//# sourceMappingURL=encoding.js.map